import { useMemo } from 'react';
import classNames from 'classnames';

function NewFundingBridgePointsWidget({
  fundingStatus,
  bridgePointsBalance,
  totalExpectedBalance,
}) {
  const remainingBridgePoints = useMemo(() => {
    if (totalExpectedBalance) {
      return totalExpectedBalance - bridgePointsBalance.openFundingBalance;
    }

    return bridgePointsBalance.openFundingRemainingBalance;
  }, [totalExpectedBalance, bridgePointsBalance]);

  const expectedBalanceOnClose = useMemo(
    () =>
      bridgePointsBalance.currentBalance -
      bridgePointsBalance.openFundingBalance -
      remainingBridgePoints,
    [bridgePointsBalance, remainingBridgePoints],
  );

  return (
    <div className="bo-border-container bg-light rounded w-100 p-0">
      <div className="p-2">
        <div className="d-flex justify-content-between pb-1">
          <p className="bo-common-text-bold">BridgePoints™</p>
        </div>
        <div className="d-flex justify-content-between pb-1">
          <p className="bo-common-text">BridgePoints™ so far</p>
          <p className="bo-common-text">
            {fundingStatus === 'CLOSED' || fundingStatus === 'CANCELLED'
              ? ''
              : Number(bridgePointsBalance.openFundingBalance).toLocaleString('en-US')}
          </p>
        </div>
        <div className="d-flex justify-content-between pb-1">
          <p className="bo-common-text">Remaining BridgePoints™</p>
          <p
            className={classNames(
              'bo-common-text',
              totalExpectedBalance && expectedBalanceOnClose < 0 && 'bo-text-red',
            )}
          >
            {fundingStatus === 'CLOSED' || fundingStatus === 'CANCELLED'
              ? ''
              : `${
                  remainingBridgePoints !== null && remainingBridgePoints !== undefined
                    ? Number(remainingBridgePoints).toLocaleString('en-US')
                    : ''
                }${totalExpectedBalance ? ' (Expected)' : ''}`}
          </p>
        </div>
        <div className="d-flex justify-content-between">
          <p className="bo-common-text">Expected BridgePoints™ balance on close</p>
          <p
            className={classNames(
              'bo-common-text',
              totalExpectedBalance && expectedBalanceOnClose < 0 && 'bo-text-red',
            )}
          >
            {fundingStatus === 'CLOSED' || fundingStatus === 'CANCELLED'
              ? ''
              : `${
                  expectedBalanceOnClose !== null && expectedBalanceOnClose !== undefined
                    ? Number(expectedBalanceOnClose).toLocaleString('en-US')
                    : ''
                }${totalExpectedBalance ? ' (Expected)' : ''}`}
          </p>
        </div>
      </div>
    </div>
  );
}

export default NewFundingBridgePointsWidget;
